export interface MessageIdentity {
  sender_name: string;
  sender_id?: string | null;
  email?: string | null;
}

export function isTeamSender(identity: MessageIdentity): boolean {
  return [identity.sender_name, identity.sender_id, identity.email]
    .filter((value): value is string => typeof value === 'string')
    .some(value => value.toLowerCase().replace(/[^a-z0-9]/g, '').includes('ugenticai'));
}
